const dictionaryReportActions = {
  DATA_MODEL_REPORT_DOWNLOAD: 'DATA_MODEL_REPORT_DOWNLOAD',
  DATA_MODEL_REPORT_DOWNLOAD_SUCCESS: 'DATA_MODEL_REPORT_DOWNLOAD_SUCCESS',
  DATA_MODEL_REPORT_DOWNLOAD_ERROR: 'DATA_MODEL_REPORT_DOWNLOAD_ERROR',
  DICTIONARY_REPORT_DOWNLOAD: 'DICTIONARY_REPORT_DOWNLOAD',
  DICTIONARY_REPORT_DOWNLOAD_SUCCESS: 'DICTIONARY_REPORT_DOWNLOAD_SUCCESS',
  DICTIONARY_REPORT_DOWNLOAD_ERROR: 'DICTIONARY_REPORT_DOWNLOAD_ERROR',
  FETCH_DATA_MODEL_REPORTS: 'FETCH_DATA_MODEL_REPORTS',
  FETCH_DATA_MODEL_REPORTS_SUCCESS: 'FETCH_DATA_MODEL_REPORTS_SUCCESS',
  FETCH_DATA_MODEL_REPORTS_ERROR: 'FETCH_DATA_MODEL_REPORTS_ERROR',
  FETCH_DICTIONARY_REPORTS: 'FETCH_DICTIONARY_REPORTS',
  FETCH_DICTIONARY_REPORTS_SUCCESS: 'FETCH_DICTIONARY_REPORTS_SUCCESS',
  FETCH_DICTIONARY_REPORTS_ERROR: 'FETCH_DICTIONARY_REPORTS_ERROR',
  HIDE_DATA_MODEL_REPORTS: 'HIDE_DATA_MODEL_REPORTS',
  HIDE_DICTIONARY_REPORT: 'HIDE_DICTIONARY_REPORT',
  HIDE_DICTIONARY_REPORTS: 'HIDE_DICTIONARY_REPORTS',
  SHOW_DATA_MODEL_REPORTS: 'SHOW_DATA_MODEL_REPORTS',
  SHOW_DICTIONARY_REPORT: 'SHOW_DICTIONARY_REPORT',
  SHOW_DICTIONARY_REPORTS: 'SHOW_DICTIONARY_REPORTS',
};

export const dictionaryReportTypes = {
  VALIDATION: 'validation',
  CONVERSION: 'conversion',
};

export default dictionaryReportActions;
